module.exports = __webpack_public_path__ + "img/welding.4d6ff3b4.webp";